import { useSelector } from 'react-redux';

import { getImageUrl } from '@features/gamification/utils';

const useMascotTheme = (
  overrideMascotDetails?: any,
  overrideLevel?: number
) => {
  const { mascotDetails, selectedSubject } = useSelector(
    (state: any) => state.user
  );

  const mascotSource = overrideMascotDetails ?? mascotDetails;
  const level = overrideLevel ?? selectedSubject?.level ?? 1;

  const currentLevelMascots =
    mascotSource &&
    mascotSource[0]?.mascotImages?.filter(
      (image: any) => image.stage === level
    );

  if (currentLevelMascots) {
    return {
      homeworkCard: {
        mascotImage: {
          active: getImageUrl({
            type: 'Happy',
            imageList: currentLevelMascots
          }),
          completedHappy: getImageUrl({
            type: 'Happy',
            imageList: currentLevelMascots
          }),
          completedNeutral: getImageUrl({
            type: 'Neutral',
            imageList: currentLevelMascots
          }),
          completedSad: getImageUrl({
            type: 'Sad',
            imageList: currentLevelMascots
          }),
          overdue: getImageUrl({
            type: 'Sad',
            imageList: currentLevelMascots
          })
        },
        textColor: 'text-blue700',
        progressBar: {
          bgColor: '#32C175',
          fgFromColor: '#E89241',
          fgToColor: '#EDAB6D'
        }
      },
      errorScreen: {
        mascotImage: getImageUrl({
          type: 'Sad',
          imageList: currentLevelMascots
        })
      },
      resultDialog: {
        correctMascotImage: getImageUrl({
          type: 'Happy',
          imageList: currentLevelMascots,
          isThumbnail: true
        }),
        partiallyCorrectMascotImage: getImageUrl({
          type: 'Neutral',
          imageList: currentLevelMascots,
          isThumbnail: true
        }),
        incorrectMascotImage: getImageUrl({
          type: 'Sad',
          imageList: currentLevelMascots,
          isThumbnail: true
        })
      },
      summaryDialog: {
        mascotImage: getImageUrl({
          type: 'Happy',
          imageList: currentLevelMascots
        })
      }
    };
  }

  return {};
};

export default useMascotTheme;
